/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs */

const en__field_enum_csjensblank_alleinstellungsmerkmal_finden39 = /** @type {(inputs: _Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`find you unique selling point`)
};

const de__field_enum_csjensblank_alleinstellungsmerkmal_finden39 = /** @type {(inputs: _Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleinstellungsmerkmal/ USP herausarbeiten`)
};

/**
* | output |
* | --- |
* | "find you unique selling point" |
*
* @param {_Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_alleinstellungsmerkmal_finden39 = /** @type {((inputs?: _Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Alleinstellungsmerkmal_Finden39Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_alleinstellungsmerkmal_finden39(inputs)
	return de__field_enum_csjensblank_alleinstellungsmerkmal_finden39(inputs)
});
export { _field_enum_csjensblank_alleinstellungsmerkmal_finden39 as "_field_enum_CSJENSBLANK_ALLEINSTELLUNGSMERKMAL_FINDEN" }